import type { ReactNode } from 'react'
import { AppIcon } from './AppIcon'

export type Tab = 'today' | 'history' | 'progress' | 'settings'

const tabs: Array<{ id: Tab; label: string }> = [
  { id: 'today', label: 'Сегодня' },
  { id: 'history', label: 'История' },
  { id: 'progress', label: 'Прогресс' },
  { id: 'settings', label: 'Настройки' }
]

export function AppShell({ tab, onTab, children, offline }: { tab: Tab; onTab: (tab: Tab) => void; children: ReactNode; offline: boolean }) {
  return (
    <div className="app-shell">
      {offline && <div className="offline-pill" role="status">Offline · всё работает локально</div>}
      <main className="app-main">{children}</main>
      <nav className="bottom-nav" aria-label="Основная навигация">
        {tabs.map((item) => (
          <button key={item.id} className={tab === item.id ? 'bottom-nav__item is-active' : 'bottom-nav__item'} onClick={() => onTab(item.id)} aria-current={tab === item.id ? 'page' : undefined}>
            <span className="bottom-nav__icon"><AppIcon name={item.id} /></span>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
    </div>
  )
}
